import React from 'react';
import NewDeck from '../../Components/NewDeck/NewDeck';
import Header from '../../Components/Header/Header';

const NewDecks = () => {
  return (
    <div>
      <Header />
      <NewDeck />
    </div>
  );
};

export default NewDecks;
